const tests = [
    {
        id: 1,
        name: "Опросник режимов SMI",
        description: "Узнайте, какие внутренние «режимы» управляют вашими эмоциями и поступками — пройдите тест SMI и взгляните на себя глубже.",
        link: "/tests/smi",
        type: "SMI",
    },
    {
        id: 2,
        name: "Опросник Дж.Янга по Определению Схем",
        description: "Узнайте, какие внутренние убеждения формируют ваши чувства, реакции и выбор — сделайте первый шаг к осознанным изменениям.",
        link: "/tests/young",
        type: "Young",
    },
    {
        id: 3,
        name: "Шкала депрессии Бека",
        description: "Узнайте, насколько выражено ваше эмоциональное напряжение и усталость — тест Бека поможет понять, стоит ли уделить больше внимания своему состоянию.",
        link: "/tests/beck",
        type: "Beck",
    },
]

export default tests;